import * as z from "zod/v4";

export const createCustomerAuthToken = {
  name: "createCustomerAuthToken" as const,
  input: z.object({
    auth: z
      .object({ email: z.string() })
      .nullish()
      .or(z.object({ orderId: z.string() }))
      .nullish(),
    email: z.string().nullish(), // TODO(devin) remove this (have to keep for backwards compatibility)
    isMerchantCreated: z.boolean().nullish(),
    merchantName: z.string().nullish(),
    merchantRoles: z.array(z.string()).nullish(),
    isGift: z.boolean().nullish(),
  }),
  output: z.object({ token: z.string(), customerId: z.string().nullish() }),
};
